<section class="seo-service">
  <div class="container-fluid">
    <div class="row center-align">
      <div class="col-md-6">
        <div class="service">

          <div>
          <h2 class="specs-header text-start ms-3">
            {{"Application and e-commerce website features" | translate}}
          </h2>
          <ul class="fa-ul text-right px-0">
            <li class="d-flex gap-2 align-items-center">
              <i class="fas fa-check"></i>
                <p class="m-1 text-start">
                  {{"Be unique by an organized and easy-to-develop software, by
                  using the latest software methodologies" | translate}}
                </p>
            </li>


            <li class="d-flex gap-2 align-items-center">
              <i class="fas fa-check"></i>
              <p class="m-1 text-start">
                {{"Create an advertising slider with the ability to modify it from the dashboard" | translate}}
              </p>
            </li>

            <li class="d-flex gap-2 align-items-center">
              <i class="fas fa-check"></i>
              <p class="m-1 text-start">
                {{"Make a list of recent products for the store and display them
                on the home page" | translate}}
              </p>
            </li>

            <li class="d-flex gap-2 align-items-center">
              <i class="fas fa-check"></i>
              <p class="m-1 text-start">
                {{"Make a list of the best selling products in the store" |
                translate}}
              </p>
            </li>

            <li class="d-flex gap-2 align-items-center">
              <i class="fas fa-check"></i>
              <p class="m-1 text-start">
                {{"Create a section for store offers and discounts" | translate}}
              </p>
            </li>
            <li class="d-flex gap-2 align-items-center">
              <i class="fas fa-check"></i>
              <p class="m-1 text-start">
                {{"Making the possibility of adding multiple sections to the
                store's products, as well as sub-sections" | translate}}
              </p>
            </li>
            <li class="d-flex gap-2 align-items-center">
              <i class="fas fa-check"></i>
              <p class="m-1 text-start">
                {{"Link the product to its own section and display the products of
                each section in its own section" | translate}}
              </p>
            </li>
            <li class="d-flex gap-2 align-items-center">
              <i class="fas fa-check"></i>
              <p class="m-1 text-start">
                {{"Create a special page for each product to display product
                details, an image and all its information" | translate}}
              </p>
            </li>
            <li class="d-flex gap-2 align-items-center">
              <i class="fas fa-check"></i>
              <p class="m-1 text-start">
                {{"Creating a basket for the store to enable you to buy more than
                one product and determine the required quantity of it" |
                translate}}
              </p>
            </li>
            <li class="d-flex gap-2 align-items-center">
              <i class="fas fa-check"></i>
              <p class="m-1 text-start">
                {{"The ability to locate the customer from the map" | translate}}
              </p>
            </li>
            <li class="d-flex gap-2 align-items-center">
              <i class="fas fa-check"></i>
              <p class="m-1 text-start">
                {{"The possibility of adding more than one address for the
                customer" | translate}}
              </p>
            </li>
            <li class="d-flex gap-2 align-items-center">
              <i class="fas fa-check"></i>
              <p class="m-1 text-start">
                {{"Possibility of electronic and cash payments" | translate}}
              </p>
            </li>
            <li class="d-flex gap-2 align-items-center">
              <i class="fas fa-check"></i>
              <p class="m-1 text-start">
                {{"Make a list of previous requests, specifying the status of the
                request for the client" | translate}}
              </p>
            </li>
            <li class="d-flex gap-2 align-items-center">
              <i class="fas fa-check"></i>
              <p class="m-1 text-start">
                {{"Make a list of the customer's favorite products" | translate}}
              </p>
            </li>
            <li class="d-flex gap-2 align-items-center">
              <i class="fas fa-check"></i>
              <p class="m-1 text-start">
                {{"Create a conversation between the customer and the store" |
                translate}}
              </p>
            </li>
          </ul>
        </div>
      </div>
      </div>
      <div class="col-md-6 text-center">
        <img src="./../../../assets/images/desktop-image-3.png" alt="seo" />
      </div>
    </div>
  </div>
</section>
